import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Header from "../Header";
import { useMemo } from "react";

const Container = styled.div`
  padding: 0 15px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
`;

const Description = styled.div`
  color: #69707f;

  font-size: 18px;
  margin: 20px 0px 40px 0px;
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.07);
  padding: 15px 0px 0px 15px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;
const TopBlock = styled.div`
  display: flex;

  align-items: center;
`;

const Icon = styled.img<{ width: number; height: number }>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin-right: 15px;
`;

const RightBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 10px;
`;

const CenterText = styled.div`
  color: #69707f;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
`;
const Text = styled.div`
  color: #69707f;
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: 400;
  white-space: break-spaces;
`;

const FeedBackText = styled.a`
  color: #0034a4;
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: 400;
  text-decoration-line: none;
  white-space: break-spaces;
`;

const SeeMoreText = styled(FeedBackText)`
  font-size: 12px;

  align-self: flex-end;
  margin-right: 10px;
`;

interface LinkItem {
  label: string;
  href: string;
  info?: string;
}

interface Partner {
  lng: string;
  link: LinkItem[];
  image: string;
  opTime: string;
  width: number;
  height: number;
  seeMoreLink?: string;
}

const partnerArray: Partner[] = [
  {
    lng: "zh-TW",
    link: [
      { label: "(+886)2-2182-1313", href: "tel:+886-02-2182-1313" },
      {
        label: "board",
        href: "https://www.esunbank.com/zh-tw/about/services/customer/message-board",
      },
    ],
    image: "esun.png",
    opTime: "esun_op_time",
    width: 89,
    height: 26,
    seeMoreLink: "https://esun.co/mmJwk",
  },
  {
    lng: "zh-TW",
    link: [
      { label: "(+886)2-6631-5190", href: "tel:+886-02-6631-5190" },
      {
        label: "board",
        href: "https://www.i-pass.com.tw/Contact/Index/021e6378-691f-4d4c-b446-5437cbf3dbe8",
      },
    ],
    image: "ips.png",
    opTime: "ips_op_time",
    width: 90,
    height: 35,
    seeMoreLink:
      "https://www.i-pass.com.tw/Faq/Index/3f83761c-ac98-4d60-8db8-53f2d59e188c",
  },
  {
    lng: "zh-TW",
    link: [
      { label: "(+886)2-8771-7212", href: "tel:+886-02-8771-7212" },
      { label: "service@jkopay.com", href: "mailto:service@jkopay.com" },
    ],
    image: "jko.png",
    opTime: "jko_op_time",
    width: 90,
    height: 50,
    seeMoreLink: "https://mkt.jkopay.com/event/paypaylogo",
  },
  {
    lng: "zh-TW",
    link: [
      { label: "(+886)2-7753-2566", href: "tel:+886-02-7753-2566" },
      { label: "board", href: "https://www.pluspay.com.tw/Forms/Service" },
    ],
    image: "plp.png",
    opTime: "plp_op_time",
    width: 90,
    height: 35,
    seeMoreLink: "https://www.pluspay.com.tw/Faq",
  },
  {
    lng: "zh-TW",
    link: [
      { label: "(+886)2-2278-5200", href: "tel:+886-02-2278-5200" },
      { label: "service@pxpayplus.com", href: "mailto:service@pxpayplus.com" },
    ],
    image: "pxp.png",
    opTime: "pxp_op_time",
    width: 89,
    height: 38,
    seeMoreLink:
      "https://www.pxpayplus.com/FAQ/%E5%A2%83%E5%A4%96%E4%BA%A4%E6%98%93",
  },

  {
    lng: "zh-HK",
    link: [
      { label: "(+852)2266 2222", href: "tel:+852-2266-2222" },
      {
        label: "WhatsApp",
        href: "https://api.whatsapp.com/send/?phone=85260377021&text=Text+Helen+to+start+a+conversation&type=phone_number&app_absent=0",
      },
    ],
    image: "ocl.png",
    opTime: "ocl_op_time",
    width: 90,
    height: 38,
    seeMoreLink: "ocl_see_more_link",
  },
  {
    lng: "zh-TW",
    link: [
      { label: "tsb_text_service", href: "https://tsbk.tw/8mzfvs/" },
      { label: "board", href: "https://tsbk.tw/8mzgjg/" },
    ],
    image: "tsb.png",
    opTime: "esun_op_time",
    width: 90,
    height: 27,
    seeMoreLink:
      "https://mkp.taishinbank.com.tw/TsCms/WebMarketing?id=WM_20260102115536649",
  },
  {
    lng: "zh-CN",
    link: [
      { info: "wcp_tel_1", label: "95017", href: "" },
      {
        info: "wcp_tel_2",
        label: "(+86)571-95017",
        href: "tel:+86-571-95017",
      },
    ],
    image: "wcp.png",
    opTime: "wcp_op_time",
    width: 90,
    height: 28,
  },
];

const Support = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const filteredArray = useMemo(() => {
    const sortArray = partnerArray.sort(function (a, b) {
      return a.image > b.image ? 1 : -1;
    });
    const supportLanguages = partnerArray.map((item) => item.lng);
    return supportLanguages.includes(currentLanguage)
      ? sortArray.filter((partner) => partner.lng === currentLanguage)
      : sortArray;
  }, [currentLanguage]);

  return (
    <>
      <Header />
      <Container>
        <Description>{t("description")}</Description>
        {filteredArray.map((partner) => {
          return (
            <Card key={partner.opTime}>
              <TopBlock>
                <Icon
                  width={partner.width}
                  height={partner.height}
                  src={`${process.env.PUBLIC_URL}/${partner.image}`}
                />
                <RightBlock>
                  <CenterText>{t("customer_center")}</CenterText>
                  {partner.link.map((item, index) => (
                    <FeedBackText
                      key={index}
                      href={item.href || undefined}
                      target="_blank"
                    >
                      {item.info && t(item.info)}
                      {t(item.label)}
                    </FeedBackText>
                  ))}
                  <Text>
                    {t("operation_time")}
                    <br />
                    {t(partner.opTime)}
                  </Text>
                </RightBlock>
              </TopBlock>
              {partner.seeMoreLink && (
                <SeeMoreText href={t(`${partner.seeMoreLink}`)} target="_blank">
                  {t("see_more")}
                </SeeMoreText>
              )}
            </Card>
          );
        })}
      </Container>
    </>
  );
};
export default Support;
